module.exports = __webpack_public_path__ + "img/lineloginnew_bak.b0ac845e.png";